<!-- <div *ngIf="showExperienceDetails" class="mr-2"> -->
  <div class="modal-body">
    <div class="row mb-4">
      <div class="col d-flex justify-content-between">
        <span class="font-weight-500">Experience Details</span>
        <button data-testid="auto-add-edit-experience-modal-button-1" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
        (click)="modalService.dismissAll()">
        <i class="fas fa-times f-14 text-black"></i>
      </button>
      </div>
    </div>
    <form [formGroup]="experience_form">
      <div class="row">
        <div class="col">
          <div class="f-12 font-weight-500 mb-4"> Job Title <span class="text-danger">*</span>
            <input data-testid="auto-add-edit-experience-modal-input-1" (input)="searchJobs($event)" type="text" placeholder="Enter Job Title"
              #trigger="matAutocompleteTrigger" (keyup.enter)="trigger.closePanel()"
              class="wc-form-control nobg mt-2 text-capitalize" formControlName="jobtitle" [matAutocomplete]="jobs_auto" [ngClass]="{'border-red':experience_form.get('jobtitle').errors?.required && (experience_form['controls'].jobtitle.dirty || experience_form['controls'].jobtitle.touched) || experience_form['controls'].jobtitle.hasError('pattern')}">
            <mat-autocomplete #jobs_auto="matAutocomplete">
              <mat-option *ngFor="let job of joblist" [value]="job">
                {{job}}
              </mat-option>
            </mat-autocomplete>
            <p *ngIf="experience_form.get('jobtitle').errors?.required && (experience_form['controls'].jobtitle.dirty || experience_form['controls'].jobtitle.touched)"
              [ngClass]="['text-left','my-1','text-danger']">Job title is required</p>
            <p *ngIf="experience_form['controls'].jobtitle.hasError('pattern') && (experience_form['controls'].jobtitle.dirty || experience_form['controls'].jobtitle.touched)" class="text-danger f-12 pt-1">
              HTML tags are not allowed</p>
          </div>
        </div>
        <div class="col">
          <div class="f-12 font-weight-500 mb-4"> Company Name <span class="text-danger">*</span>
            <input data-testid="auto-add-edit-experience-modal-input-2" (input)="searchCompany($event)" type="text" placeholder="Enter Company Name"
              #trigger="matAutocompleteTrigger" (keyup.enter)="trigger.closePanel()"
              class="wc-form-control nobg mt-2 text-capitalize" formControlName="companyname" [matAutocomplete]="company_auto" [ngClass]="{'border-red':experience_form.get('companyname').errors?.required && (experience_form['controls'].companyname.dirty || experience_form['controls'].companyname.touched) ||  experience_form['controls'].companyname.hasError('pattern')}">
            <mat-autocomplete #company_auto="matAutocomplete">
              <mat-option *ngFor="let company of companylist" [value]="company">
                {{company}}
              </mat-option>
            </mat-autocomplete>
            <p *ngIf="experience_form.get('companyname').errors?.required && (experience_form['controls'].companyname.dirty || experience_form['controls'].companyname.touched)"
              [ngClass]="['text-left','my-1','text-danger']">Company Name is required</p>
            <p *ngIf="experience_form['controls'].companyname.hasError('pattern') && (experience_form['controls'].companyname.dirty || experience_form['controls'].companyname.touched)" class="text-danger f-12 pt-1">
              HTML tags are not allowed</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="f-12 font-weight-500 mb-4"> Work Location <span class="text-danger">*</span>
            <input data-testid="auto-add-edit-experience-modal-input-3" (input)="searchLocation($event)" type="text" placeholder="Enter Work Location"
              #trigger="matAutocompleteTrigger" (keyup.enter)="trigger.closePanel()"
              class="wc-form-control nobg mt-2 text-capitalize" formControlName="worklocation" [matAutocomplete]="location_auto" [ngClass]="{'border-red':experience_form.get('worklocation').errors?.required && (experience_form['controls'].worklocation.dirty || experience_form['controls'].worklocation.touched) || experience_form['controls'].worklocation.hasError('pattern')}">
            <mat-autocomplete #location_auto="matAutocomplete">
              <mat-option *ngFor="let location of locationlist" [value]="location">
                {{location}}
              </mat-option>
            </mat-autocomplete>
            <p *ngIf="experience_form.get('worklocation').errors?.required && (experience_form['controls'].worklocation.dirty || experience_form['controls'].worklocation.touched)"
              [ngClass]="['text-left','my-1','text-danger']">Work Location is required</p>
            <p *ngIf="experience_form['controls'].worklocation.hasError('pattern') && (experience_form['controls'].worklocation.dirty || experience_form['controls'].worklocation.touched)" class="text-danger f-12 pt-1">
              HTML tags are not allowed</p>
          </div>
        </div>
        <div class="col">
          <label for="">&nbsp;</label>
          <div class="d-flex align-items-center mb-4 mt-1">
            <label class="wc-checkbox mr-2 mb-0">
              <input data-testid="auto-add-edit-experience-modal-input-4" type="checkbox" id="mycheck" name="mycheck" (click)="currentlyWorkingChecked($event);"
                formControlName="currentyear">
              <i class="fas fa-check"></i>
            </label>
            <label class="mb-0" for="mycheck">
              <span class="f-14">Currently Working</span>
            </label>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-6" formGroupName="startdate">

          <label class="f-12 font-weight-500 mb-2"> Start Date <span
              class="text-danger">*</span> </label>

              <div class="row">
                <div class="col">
                  <div class="position-relative">
                    <select data-testid="auto-add-edit-experience-modal-select-1"  class="nobg wc-form-control position-relative z1" formControlName="month" [ngClass]="{'border-red':experience_form.get('startdate')['controls'].month.errors?.required && (experience_form['controls']['startdate']['controls'].month.dirty || experience_form['controls']['startdate']['controls'].month.touched)}" >
                    <option [value]="null" disabled>Month</option>
                    <option [value]="month.id" *ngFor="let month of months">{{month.name}}</option>
                  </select>
                  <span class="selectdrop-down position-absolute  text-bluex topright1"><i
                    class="far fa-calendar-minus f-14"></i> </span>
                </div>
                <p class="f-12 font-weight-500" *ngIf="experience_form.get('startdate')['controls'].month.errors?.required && (experience_form['controls']['startdate']['controls'].month.dirty || experience_form['controls']['startdate']['controls'].month.touched)"
              [ngClass]="['text-left','my-1','text-danger']">Start month is required</p>
                </div>
                <div class="col">
                  <div class="position-relative">
                    <select data-testid="auto-add-edit-experience-modal-select-2" class="nobg wc-form-control position-relative z1" formControlName="year" [ngClass]="{'border-red':experience_form.get('startdate')['controls'].year.errors?.required && (experience_form['controls']['startdate']['controls'].year.dirty || experience_form['controls']['startdate']['controls'].year.touched)}">
                      <option [value]="null" disabled selected>Year</option>
                      <option *ngFor="let x of year_list" [value]="x">{{x}}</option>
                    </select>
                    <span class="selectdrop-down position-absolute text-bluex topright1"><i class="far fa-calendar f-14"></i></span>
                  </div>
                  <p class="f-12 font-weight-500" *ngIf="experience_form.get('startdate')['controls'].year.errors?.required && (experience_form['controls']['startdate']['controls'].year.dirty || experience_form['controls']['startdate']['controls'].year.touched)"
              [ngClass]="['text-left','my-1','text-danger']">Start year is required</p>
                  </div>
              </div>

          </div>
        <div class="col-6" *ngIf="iscurrent == 0" formGroupName="enddate">
          <label class="f-12 font-weight-500 mb-2"> End Date <span
              class="text-danger">*</span> </label>
              <div class="row">
                <div class="col">
                  <div class="position-relative">
                    <select data-testid="auto-add-edit-experience-modal-select-3"  class="nobg wc-form-control position-relative z1" formControlName="month" [ngClass]="{'border-red':experience_form.get('enddate').controls.month.errors?.required && (experience_form['controls']['enddate'].controls.month.dirty || experience_form['controls']['enddate'].controls.month.touched)}">
                    <option [value]="null" disabled>Month</option>
                    <option [value]="month.id" *ngFor="let month of months">{{month.name}}</option>
                  </select>
                  <span class="selectdrop-down position-absolute  text-bluex topright1"><i
                    class="far fa-calendar-minus f-14"></i> </span>
                </div>
                <p class="f-12 font-weight-500" *ngIf="experience_form.get('enddate').controls.month.errors?.required && (experience_form['controls']['enddate'].controls.month.dirty || experience_form['controls']['enddate'].controls.month.touched)" [ngClass]="['text-left','my-1','text-danger']">End month is required</p>
                </div>
                <div class="col">
                  <div class="position-relative">
                    <select data-testid="auto-add-edit-experience-modal-select-4" class="nobg wc-form-control position-relative z1" formControlName="year" [ngClass]="{'border-red':experience_form.get('enddate').controls.year.errors?.required && (experience_form['controls']['enddate'].controls.year.dirty || experience_form['controls']['enddate'].controls.year.touched)}">
                      <option [value]="null" disabled selected>Year</option>
                      <option *ngFor="let x of year_list" [value]="x">{{x}}</option>
                    </select>
                    <span class="selectdrop-down position-absolute text-bluex topright1">
                      <i class="far fa-calendar f-14"></i> </span>
                  </div>
                  <p class="f-12 font-weight-500" *ngIf="experience_form.get('enddate').controls.year.errors?.required && (experience_form['controls']['enddate'].controls.year.dirty || experience_form['controls']['enddate'].controls.year.touched)" [ngClass]="['text-left','my-1','text-danger']">End year is required</p>
                  </div>
              </div>
              <p class="text-danger f-12 pt-1 font-weight-500"
              *ngIf="experience_form['controls']['enddate'].hasError('DateValidation')">
              End date should be greater than start date.</p>


            </div>
      </div>
      <p class="f-12 font-weight-500" *ngIf="experience_form['controls'].enddate.hasError('incorretexperience')"
      [ngClass]="['text-left','my-1','text-danger']">End year should be greater than start year.</p>

      <div class="row">
        <div class="col">
          <p class="f-12 font-weight-500 mb-2"> Work Description </p>
          <textarea data-testid="auto-add-edit-experience-modal-textarea-1" type="text" placeholder="Enter Work Description " class="wc-form-control nobg mb-3 h-105"
            formControlName="workdescription" cols="30" rows="10" [ngClass]="{'border-red':(experience_form['controls'].workdescription.hasError('pattern') && ((experience_form['controls'].workdescription.dirty || experience_form['controls'].workdescription.touched)))}"> </textarea>
          <p *ngIf="(experience_form['controls'].workdescription.hasError('pattern') && ((experience_form['controls'].workdescription.dirty || experience_form['controls'].workdescription.touched)))" class="text-danger f-12 pt-1">
            HTML tags are not allowed</p>
        </div>
      </div>
      <div class="row">
        <div class="col text-right" >
          <button data-testid="auto-add-edit-experience-modal-button-2" type="button" class="btn-trms-small" data-dismiss="modal" [disabled]="addExperienceSpinner"
            (click)="addexperience()">
               <span [ngClass]="{ 'spinner-border text-light spinner-size': addExperienceSpinner }" [ngStyle] = "{ 'width: 20px; height: 20px;': addExperienceSpinner }">
          {{addExperienceSpinner ? '' : 'Save'}}
        </span>
      </button>
        </div>
      </div>
    </form>
  </div>
  <!-- </div> -->
